import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const sort_list = [
  { label: "Best Seller", value: "-priority" },
  { label: "Highest Price", value: "-payable_amount" },
  { label: "Lowest Price", value: "payable_amount" },
];

const useSort = () => {
  const [sort_modal, set_sort_modal] = useState(false);
  const [active_sort, set_active_sort] = useState("-priority");

  const navigate = useLangNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   set_active_sort('-priority');
  // }, [history.location.pathname])

  useEffect(() => {
    const parsed_query = parse(location.search);
    if (
      !(!parsed_query.sort && active_sort === "-priority") ||
      !parsed_query.sort === active_sort
    ) {
      parsed_query.sort = active_sort;
      const new_url = `${location.pathname}?${stringify(parsed_query)}`;
      navigate(new_url);
    }
    // eslint-disable-next-line
  }, [active_sort]);

  const activeSortLabel = sort_list.find(
    (item) => item.value === active_sort
  ).label;

  return [
    sort_modal,
    set_sort_modal,
    active_sort,
    set_active_sort,
    sort_list,
    activeSortLabel,
  ];
};

export default useSort;
